import { Link } from 'react-router-dom';

const footerLinks = {
  service: {
    title: '产品服务',
    links: [
      { label: '体育竞技', href: '/categories' },
      { label: '真人视讯', href: '/categories' },
      { label: '电子游艺', href: '/categories' },
      { label: '彩票游戏', href: '/categories' },
      { label: '电子竞技', href: '/categories' },
      { label: '捕鱼游戏', href: '/categories' },
    ],
  },
  support: {
    title: '帮助支持',
    links: [
      { label: '常见问题', href: '/#faq' },
      { label: '安全指南', href: '/articles' },
      { label: '支付说明', href: '/articles' },
      { label: '责任博彩', href: '/articles' },
      { label: '联系我们', href: '/about' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '平台信誉', href: '/about' },
      { label: '联系方式', href: '/about' },
      { label: '最新资讯', href: '/articles' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-cloud-line text-xl text-background-50 w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-900">开云</span>
            </Link>
            <p className="text-sm text-secondary-600 leading-relaxed mb-4">
              开云官网是开云平台的官方正版渠道，提供安全、稳定、极致的在线娱乐体验。专业团队全天候服务，保障您的账户与资金安全。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-secondary-500 hover:text-primary-500 hover:bg-primary-500/10 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-secondary-500 hover:text-primary-500 hover:bg-primary-500/10 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-200 flex items-center justify-center text-secondary-500 hover:text-primary-500 hover:bg-primary-500/10 transition-all duration-200 cursor-pointer" aria-label="邮箱">
                <i className="ri-mail-line text-lg w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h3 className="text-sm font-semibold text-foreground-900 mb-4 uppercase tracking-wider">
                {section.title}
              </h3>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-secondary-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-secondary-500">
            &copy; {new Date().getFullYear()} 开云官网 Kaiyun.com 版权所有
          </p>
          <div className="flex items-center gap-6">
            <Link to="/" className="text-sm text-secondary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              隐私政策
            </Link>
            <Link to="/" className="text-sm text-secondary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              服务条款
            </Link>
            <Link to="/" className="text-sm text-secondary-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
              责任博彩
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}